<template>
  <footer class="footer-wrap">
    <div class="footer">
      <ul class="footer-ul">
        <li>
          <a title="网店管家" href="http://www.wdgj.com" target="_blank"
            rel="noopener noreferrer external nofollow">网店管家</a>
        </li>
        <li>
          <a title="web版登录" href="https://web.jackyun.com" target="_blank"
            rel="noopener noreferrer external nofollow">web版登录</a>
        </li>
        <li>
          <a title="云课堂" href="/pages/yunClass.html" target="_blank" rel="noopener noreferrer">云课堂</a>
        </li>
        <li>
          <a title="用户手册" href="/pages/space.html"
            target="_blank" rel="noopener noreferrer external nofollow">用户手册</a>
        </li>
        <li>
          <a title="开放平台" href="http://open.jackyun.com/" target="_blank"
            rel="noopener noreferrer external nofollow">开放平台</a>
        </li>
        <li>
          <a title="代理商招募" href="/pages/agent.html" target="_blank"
            rel="noopener noreferrer">代理商招募</a>
        </li>
        <li>
          <a title="销售合伙人招募" href="/pages/partner.html" target="_blank" rel="noopener noreferrer">销售合伙人招募</a>
        </li>
        <li>
          <a title="市场动态" href="/official/marketDynamic" target="_blank" rel="noopener noreferrer">市场动态</a>
        </li>
        <li>
          <a title="行业资讯" href="https://info.jackyun.com" target="_blank" rel="noopener noreferrer">行业资讯</a>
        </li>
        <!-- <li style="position: relative;">
          <a title="PDA软件下载" href="https://upgrade.jackyun.com/jackyun-pda/jackyun.apk  " target="_blank"
            rel="noopener noreferrer external nofollow">PDA软件下载</a>
        </li> -->

      </ul>
      <div class="tableContainer">
        <div class="footer-item">
          <div class="footer-name">吉客云总部</div>
          <hr />
          <div class="footer-address">
            浙江省杭州市西湖区
            <br />西湖科技园西园路10号
            <br />尚坤生态创意园A区1-3F
          </div>
        </div>
        <div class="footer-item">
          <div class="footer-name">北京服务中心</div>
          <hr />
          <div class="footer-address">
            北京市通州区
            <br />砖厂南里47号华远好天地
            <br />B座708室
          </div>
        </div>
        <div class="footer-item">
          <div class="footer-name">广州服务中心</div>
          <hr />
          <div class="footer-address">
            广州市海珠区
            <br />大干围38号海珠创意产业园
            <br />12栋南梯403室
          </div>
        </div>
        <div class="footer-item">
          <div class="footer-name">合肥服务中心</div>
          <hr />
          <div class="footer-address">
            安徽省合肥市蜀山区
            <br />振兴路666号顺丰丰泰产业园
            <br />1118室
          </div>
        </div>
        <div class="footer-item">
          <div title="西安研发中心" class="footer-name">西安研发中心</div>
          <hr />
          <div class="footer-address">
            陕西省西安市雁塔区
            <br />科创路168号
            <br />E座25B
          </div>
        </div>
      </div>
      <!-- <hr /> -->
      <!-- <div class="footer-bottom">
        <div class="friend-link">
        </div>
      </div> -->
      <div class="bottom-line">
        <div class="bottom-right pd-top">
          <a href="https://www.jackyun.com/Htmls/rule.html?docId=918E704BF985745971006383D311623C" target="_blank"
            rel="noopener noreferrer external nofollow">隐私协议</a>&nbsp;
          版权所有(C) 2017-2020 杭州吉客云网络技术有限公司&nbsp;&nbsp;&nbsp;
          <a href="http://beian.miit.gov.cn/" target="_blank"
            rel="noopener noreferrer external nofollow">浙ICP备18019426号-1</a>
          <img src="/static/img/imgs/police-icon.png" alt="吉客云-浙公网安备" />
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014798" target="_blank"
            rel="noopener noreferrer external nofollow">浙公网安备 33011002014798号</a>
          <a href="https://new.cnzz.com/v1/login.php?siteid=1279031780" target="_blank"
            rel="noopener noreferrer external nofollow">&nbsp;&nbsp;站长统计</a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import {Popover} from "element-ui";
export default {
  name: "myfooter",
    components: {
    "el-popover": Popover,
  },
  methods: {
    goRouter(url) {
      window.open(url, "_blank");
    },
    download(){
      window.location.href="https://upgrade.jackyun.com/jackyun-pda/jackyun.apk  "
    },
    //去外链
    goWebsite() {
      window.open("https://www.yuque.com/jkyun/jky/seb8n9");
    },
  }
};
</script>

<style lang="less" scoped>
.footer-wrap {
  width: 100%;
  background: #5D5D5D;
  background-size: 100% 100%;
}

.tableContainer {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.footer-item {
  width: 210px;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.footer-name {
  font-size: 14px;
  line-height: 40px;
  color: rgba(255, 255, 255, 1);
}

.footer-address {
  font-size: 14px;
  line-height: 24px;
  color: rgba(255, 255, 255, 1);
  opacity: 0.7;
  margin: 10px 0 13px 0;
}

.footer-bottom {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}

.bottom-line {
  background-color: #414141;
}

.friend-link p {
  margin: 13px 0 18px 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  opacity: 0.8;
}

.friend-link p a {
  color: rgba(255, 255, 255, 0.7);
}

.friend-link p a:hover {
  color: #5485E8;
}


.bottom-right {
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  line-height: 20px;
  padding: 17px 0;
  display: flex;
  justify-content: center;
}

.bottom-right a {
  display: block;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  line-height: 20px;
}

.bottom-right img {
  width: 20px;
  height: 20px;
  margin: 0 7px 0 15px;
}

hr {
  width: 99%;
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 1);
  opacity: 0.15;
}

.footer-txt {
  display: flex;
  justify-content: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
  margin-top: 20px;
}

.footer-txt img {
  width: 15px;
  height: 17px;
  margin: 2px;
}

.footer-txt a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
}

.footer-ul {
  display: flex;
  color: #fff;
  font-size: 18px;
  justify-content: center;
  padding: 40px 0;
  margin: 0;
}

.footer-ul li {
  line-height: 15px;
  padding: 0 10px;
  border-right: 1px solid #fff;
}

.footer-ul li a {
  color: #fff;
}

.footer-ul li:hover {
  color: #5485E8 !important;
}

.footer-ul li a:hover {
  color: #5485E8 !important;
}

.footer-ul li:last-child {
  border-right: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/footer-wrap.vue